module.exports = __webpack_public_path__ + "static/img/COC2023-17.45a7125.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-17.png
// module id = 0PI6
// module chunks = 0